import React, {memo, useRef} from 'react'
import {
    Box,
    Text,
    useMultiStyleConfig,
    IconButton
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage} from 'react-intl'
import useTagManager from '../../../hooks/use-tag-manager'

const CartPurpledotBanner = memo(() => {
    const cartStyles = useMultiStyleConfig('CartStyles')
    const preorderBagRef = useRef(null)
    const tagManager = useTagManager()

    const handleClick = (event) => {
        // If the custom Purple Dot element handled the click, don't re-trigger it.
        if (event?.target?.closest?.('purple-dot-separate-bag')) {
            return
        }

        const purpleDotSeparateBag =
            preorderBagRef.current?.querySelector('purple-dot-separate-bag')
        if (purpleDotSeparateBag) {
            purpleDotSeparateBag.click()
            tagManager.openPdBasket('cart')
            return
        }
    }

    return (
        <Box
            className="cart-purpledot-banner hide-element"
            {...cartStyles.boxStyles}
            sx={{
                '&.hide-element': {
                    display: 'none'
                }
            }}
        >
            <Text {...cartStyles.titleTextStyles}>
                <FormattedMessage
                    defaultMessage="Looking for your Pre-Order items?"
                    id="purple_dot.cart.bannertext"
                />
            </Text>
            <Text
                className="purpledot-banner-preorder-bag"
                {...cartStyles.preorderBagStyles}
                onClick={handleClick}
                ref={preorderBagRef}
            >
                <IconButton
                    sx={{
                        'purple-dot-separate-bag svg': {
                            width: {base: '16px', lg: '18px'},
                            height: {base: '20px', lg: '20px'},
                            stroke: 'purple.700'
                        },
                        '.purple-dot-separate-bag__indicator': {
                            width: '5px',
                            height: '5px',
                            top: '6px',
                            backgroundColor: {
                                base: 'purple.90',
                                lg: 'purple.90'
                            },
                            right: '-1px'
                        }
                    }}
                    aria-label="Purple Dot Icon"
                    icon={<purple-dot-separate-bag />}
                    variant="unstyled"
                    minWidth="auto"
                    height="auto"
                />
                <FormattedMessage
                    defaultMessage="Pre-Order Bag"
                    id="purple_dot.cart.preorder_bag"
                />
                <Text as="label" className="purpledot-banner-item-count"></Text>
            </Text>
        </Box>
    )
})

CartPurpledotBanner.displayName = 'CartPurpledotBanner'

export default CartPurpledotBanner
